<template>
  <div>
    <b-row>
      <b-col cols="6">
        <b-card header-tag="header" style="height: 30rem;">
          <template v-slot:header>
            <h6 class="mb-0">Historic Predictive Risk Indicators</h6>
          </template>
          <b-row class="text-center">
            <b-col cols="12">
              <b-avatar variant="light" text=" "></b-avatar>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col cols="12">
              <h4>NOT IN SCOPE. Please Contact Us should you wish to discuss provisioning this service on your account.</h4>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col cols="6">
        <b-card header-tag="header" style="height: 30rem;">
          <template v-slot:header>
            <h6 class="mb-0">Future Predictive Risk Benchmarks</h6>
          </template>
          <b-row class="text-center">
            <b-col cols="12">
              <b-avatar variant="light" text=" "></b-avatar>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col cols="12">
              <h4>NOT IN SCOPE. Please Contact Us should you wish to discuss provisioning this service on your account.</h4>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col cols="12">
              <h6>Labour Practices</h6>
              <p>Chart</p>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col cols="12">
              <h6>Health & Safety</h6>
              <p>Chart</p>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  name: "LabourPredictiveRisk",
  data() {
    return {};
  }
};
</script>